import { Component } from '@angular/core';
import { Project } from 'src/app/models/project';
import { PORTFOLIO, SKILS, SOCIAL_NETWORKS } from './landingpage.string';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss']
})
export class LandingpageComponent {
  
  social = SOCIAL_NETWORKS;
  skills = SKILS;
  projects: Project[] = PORTFOLIO;
  projectSelected: Project = new Project('','','');

  constructor() { }

  setProject( project:Project ){
    this.projectSelected = project;
  }
}
